import Context from "../context/context";
import React, { useContext } from 'react';


function FilterCount(props){
    const {name} = props;
    const {selectedFilters, setSelectedFilters} = useContext(Context);
    let count = 0;

    selectedFilters.forEach((selected_filter) => {
        if (selected_filter.type == "checkboxes" && selected_filter.name == name){
            selected_filter.elements.forEach((element) => {
                if (element.value){
                    count += 1;
                }
            })
        }
        if (selected_filter.type == "date" && selected_filter.name == name){
            selected_filter.elements.forEach((element) => {
                if (element.value != ""){
                    count = 1;
                }
            })
        }
    })

    return (
        <>
          <span className={`filter-count ${count > 0 ? 'active' : ''}`}>{count}</span>
        </>
    )
}

export default FilterCount;
